import LiveTag from "src/shared/components/LiveTag";
import { t } from "src/shared/locales/i18n";
import { DivProductImage } from "../style/ProductImage.style";

export type ProductImageVariant = "normal" | "highlight" | "modal" | "combined";
interface Props {
  src: string;
  variant?: ProductImageVariant;
  alt?: string;
}

const ProductImage = ({ src, variant = "normal", alt = "" }: Props) => {
  return (
    <DivProductImage className="akn-product-image-container" $variant={variant}>
      {variant !== "normal" && <LiveTag />}
      <img className="akn-product-image" src={src} alt={alt} />
    </DivProductImage>
  );
};

export default ProductImage;
